import { Component, OnInit, ViewChild } from '@angular/core';
import { ISearchMidwifeBody } from 'src/app/models/dashboard.models';
import { ProfileListComponent } from './components/profile-list/profile-list.component';

@Component({
  selector: 'app-search-listing',
  templateUrl: './search-listing.component.html',
  styleUrls: ['./search-listing.component.scss']
})
export class SearchListingComponent implements OnInit {

  @ViewChild(ProfileListComponent) profileList: ProfileListComponent;

  constructor() { }

  ngOnInit(): void {
  }

  searchMidwife(searchParam: ISearchMidwifeBody){
    this.profileList.body = searchParam;
    this.profileList.showLoadMore = true;
    this.profileList.midwifes = [];
    this.profileList.getMidwifeList();
  }

  clearFilter(){
    this.profileList.ngOnInit();
  }
}